<template>
  <div
    class="ui-signingSequence-SigningSequenceEditor relative">
    <h3>
      {{ $t('signingSequence.ui.title')}}
    </h3>
    <button
      @click="showModal"
      type="button"
      class="tw-button absolute top-0 right-0"
      data-ec="signing_sequence"
      data-et="btn_edit"
      data-test="button-modal">
      <span class="px-base">{{ $t('functional.edit') }}</span>
    </button>
    <div class="ml-base">
      <ParallelLabel
        v-if="value === 'parallel'"
        data-test="label-parallel"
      />
      <SequentialLabel
        v-else
        data-test="label-sequential"
      />
    </div>

    <EditModal
      :show="displayModal"
      :currentSelection="value"
      @selectionSaved="selectionSaved"
      @close="hideModal"
      data-test="modal"
    />
  </div>
</template>

<script>
import ParallelLabel from '@/components/ui/signingSequence/labels/ParallelLabel.vue';
import SequentialLabel from '@/components/ui/signingSequence/labels/SequentialLabel.vue';
import EditModal from '@/components/ui/signingSequence/modals/EditModal.vue';

export default {
  name: 'SigningSequenceEditor',
  components: {
    ParallelLabel,
    SequentialLabel,
    EditModal,
  },
  props: {
    currentSelection: {
      type: String,
      required: true,
      validator(value) {
        return ['parallel', 'sequential'].includes(value);
      },
    },
  },
  data() {
    return {
      displayModal: false,
      value: this.currentSelection,
    };
  },
  watch: {
    currentSelection(newValue) {
      this.value = newValue;
    },
  },
  methods: {
    showModal() {
      this.displayModal = true;
    },
    hideModal() {
      this.displayModal = false;
    },
    selectionSaved(value) {
      this.$emit('selectionUpdated', value);
    },
  },
};
</script>
